module.exports = __webpack_public_path__ + "img/patrik_tschachtli.b3c7df9e.png";